import React from 'react'
import PropTypes from 'prop-types'
import { emptyList } from './EmptyList.module.scss'

const EmptyList = ({ message }) => {
  return <div className={emptyList}>{message}</div>
}

EmptyList.propTypes = {
  message: PropTypes.string.isRequired,
}

EmptyList.defaultProps = {}

export default React.memo(EmptyList)
